import React from "react";

const TwitterIcon = ({ color = "#FFF", withPadding = false }) => {
  if (withPadding) {
    return (
      <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.7142 13.6226L23.4162 6H21.8286L16.0068 12.6173L11.3604 6H6L13.0278 16.0075L6 24H7.5876L13.7316 17.0104L18.6396 24H24M8.1606 7.17142H10.5996L21.8274 22.8861H19.3878"
          fill={color || "#FFF"}
        />
      </svg>
    );
  }

  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0951 13.3166L25.2865 4H23.3461L16.2305 12.0878L10.5516 4H4L12.5895 16.2313L4 26H5.9404L13.4497 17.4572L19.4484 26H26M6.64073 5.43174H9.62173L23.3446 24.6386H20.3629"
        fill={color || "#FFF"}
      />
    </svg>
  );
};

export default TwitterIcon;
